import { Component, OnInit } from '@angular/core';
import { LabelComponent } from '../label/label.component';


@Component({
    selector: 'app-report-header-default',
    templateUrl: './report-header-default.component.html',
    styleUrls: ['./report-header-default.component.scss'],
    standalone: false
})
export class ReportHeaderDefaultComponent extends LabelComponent implements OnInit {
    static componentName = 'ReportHeaderDefaultComponent';



    ngOnInit() {
    }

}
